import React, { createContext, useContext, useState } from 'react'

interface PainterMenuContextValue {
  menuOpen: boolean
  setMenuOpen: React.Dispatch<React.SetStateAction<boolean>>
  notificationsOpen: boolean
  setNotificationsOpen: React.Dispatch<React.SetStateAction<boolean>>
}

const defaultValue: PainterMenuContextValue = {
  menuOpen: false,
  setMenuOpen: () => {},
  notificationsOpen: false,
  setNotificationsOpen: () => {}
}

export const PainterMenuContext = createContext<PainterMenuContextValue>(defaultValue)

export function usePainterMenuContext() {
  return useContext(PainterMenuContext)
}

export function PainterMenuProvider({ children }: { children: React.ReactNode }) {
  const [menuOpen, setMenuOpen] = useState(false)
  const [notificationsOpen, setNotificationsOpen] = useState(false)

  return (
    <PainterMenuContext.Provider value={{ menuOpen, setMenuOpen, notificationsOpen, setNotificationsOpen }}>
      {children}
    </PainterMenuContext.Provider>
  )
}
